import React from 'react';
import { isNil } from 'lodash';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import {
  SubHeader,
  Controls,
  InlineControl,
  Reset,
  InlineNumber,
} from '../../reporting/sidebar/components';

function DataFormattingConfig({ axis }) {
  const { get } = useReportConfiguration();

  return (
    <>
      <SubHeader>Data boundaries</SubHeader>
      <Controls>
        <InlineControl>
          <InlineNumber configurationKey='minValue' size='small'>
            Min
          </InlineNumber>
          <InlineNumber configurationKey='maxValue' size='small'>
            Max
          </InlineNumber>
          <Reset
            label={`Reset ${axis} axis boundaries`}
            configurationKeys={['minValue', 'maxValue']}
            className='ml-auto'
            disabled={isNil(get('minValue')) && isNil(get('maxValue'))}
          />
        </InlineControl>
      </Controls>
    </>
  );
}
export default DataFormattingConfig;
